/* Where the screens of the simulation are. The order of their routes matters: "new" and "workspaces" would be taken for the id of a run. */
export const SimulationPath = Object.freeze({
    RUNS: '/simulations',
    WORKSPACES: '/simulations/workspaces',
    NEW_RUN: '/simulations/new',
    TEST_CHANGE: '/simulations/test-change',
    run: runId => `/simulations/${runId}`,
    comparison: (baselineRunId, variantRunId) =>
        `/simulations/comparisons/${baselineRunId}/${variantRunId}`
});
